import React, {FunctionComponent} from 'react'
import {Navbar,Nav, Button,Container,Card,Row,ButtonGroup} from 'react-bootstrap'
// import * as d3 from 'd3'
import { FaPowerOff } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

import { SankeyData }  from 'open-sankey/src/types/Types'
import { logOutUser } from '../Login/LoginFunctions'
import { NavigateFunction } from 'react-router-dom'
import { DefaultSankeyDataFuncType } from 'open-sankey/src/configmenus/types/SankeyUtilsTypes'
import { ConvertDataFuncType } from 'open-sankey/src/configmenus/types/SankeyConvertTypes'
import { ClickSaveExcel } from '../../import/OpenSankey'


export type SankeyLabelTypes = {
  idLabel: string,
  title:string,
  content: string,
  opacity:number,
  color:string,
  color_border:string,
  transparent_border:boolean,

  label_width: number,
  label_height: number,

  x: number,
  y: number,

  is_image:boolean,
  image_src:string
}

export type DashboardTypes = {
  navbar_logo: string,
  navbar_logo_width: number,
  navbar_app_version: string,
  token:boolean,
  exemple_menu: object,
  data: SankeyData,
  set_data : (_:SankeyData)=>void,
  unsetTokens: ()=>void
  useNavigate: ()=>NavigateFunction,
  suite_convert_data:ConvertDataFuncType,
  SuiteDefaultData:DefaultSankeyDataFuncType
}

// Dashboard, Register or Buy License
const Dashboard:FunctionComponent<DashboardTypes>=({
  navbar_logo, navbar_logo_width, navbar_app_version,
  token,
  data, set_data,
  unsetTokens,
  useNavigate,
  suite_convert_data,
  SuiteDefaultData
})=>
{
  // Initialise traduction function
  const {t} = useTranslation()
  // Define navigation behaviour to return to App
  const navigate=useNavigate()
  const returnToApp=()=>{
    navigate('/')
    set_data({...data})
  }

  //If we acces this page without being logged, it is resent to the application
  if(!token){
    returnToApp()
  }

  //If we are log the the following behaviors are defined
  //Go to myAccount
  const myAccount=()=>{
    navigate('/account')
  }
  //Logout
  const loginOut=()=>{
    logOutUser(unsetTokens)
    returnToApp()
  }

  /* eslint-disable */
  // @ts-ignore
  const list_template = require.context('../../css/easy_template', true)
  // @ts-ignore
  const list_template_data = list_template.keys().filter(k=>k.includes('.json')).map(image => list_template(image))
  // @ts-ignore
  const names = list_template.keys().filter(k=>k.includes('.json'))
  // @ts-ignore
  const image_preview = require.context('../../css/image_preview', true)
  // @ts-ignore
  const imageList = image_preview.keys().map(image => {
    let img = image_preview(image)
    const path = window.location.href
    if ( !path.includes('localhost') ) {    
      img = img.replace('static/', 'static/sankeysuite/')
    }
    return img
  })
  /* eslint-enable */
  const modalTemplate=
  <>
    {(list_template_data as SankeyData[]).map((_,idx) =>
    {
      const title=names[idx].slice(2).split('.').splice(0,1).join('')
      suite_convert_data(_,SuiteDefaultData)
      return(
        <Card>
          <Card.Img className='img-card' variant="top" src={imageList[idx]} style={{'objectFit':'contain','maxHeight':'150px'}} />
          <Card.Body>
            <Card.Title>{title.split('_').join(' ')}</Card.Title>
            <ButtonGroup>
              <Button variant='primary'
                onClick={() => {
                  navigate('/')

                  set_data({..._})
                }

                }
              >{t('useTemplate')}</Button>
              <Button variant='info'
                onClick={() => {
                  // const difficulty_file=(tmp['Formations']['Démos']['OpenSankey']['easy_template'].includes(list_template_data[idx]))?'easy_template':'expert_template'
                  //DownloadExempleExcel(imageList[idx].replace('png','json'))
                  ClickSaveExcel('/opensankey/',_)
                }

                }
              >{t('dl')}</Button>
            </ButtonGroup>
          </Card.Body>
        </Card>
      )})}
  </>

  return(
    <div>
      <Navbar className='bg-light navbar-dashboard' fixed='top' style={{ 'display': 'block' }} >
        <Container className='MenuNavigation'>
          <Navbar.Brand href="/" rel="noopener noreferrer"><img src={navbar_logo} alt='navigation logo' width={navbar_logo_width ? navbar_logo_width : 200} /> {navbar_app_version} </Navbar.Brand>
          <Nav>
            <Nav.Item>
              <Button variant='light' onClick={()=>returnToApp()}>{t('UserPages.to_app')}</Button>
            </Nav.Item>
            <Nav.Item>
              <Button variant='light' onClick={()=>myAccount()}>{t('UserPages.to_acc')}</Button>
            </Nav.Item>
            <Nav.Item>
              <Button variant='danger' onClick={()=>loginOut()}><FaPowerOff/></Button>
            </Nav.Item>
          </Nav>
        </Container>
      </Navbar>

      <Card style={{'marginTop':'85px'}}>
        <Card.Header>{t('UserPages.win_db_template')}</Card.Header>
        <Card.Body>
          <Row md={4}>
            {modalTemplate}
          </Row>
        </Card.Body>
      </Card>

    </div>
  )
}

export default Dashboard




